import styled from 'styled-components';

import { Button, FontWeights, Text } from '@calm-web/design-system';

import CalmLogoCircle from 'icons/calm-logo-circle.svg';

export const Header = styled.header`
	border-bottom: 1px solid #e5e7eb;
	background-color: white;
	position: sticky;
	top: 0;
	z-index: 50;
`;

export const Container = styled.div`
	max-width: 1200px;
	margin: 0 auto;
	padding: 10px 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
`;

export const LogoLink = styled.div`
	text-decoration: none;
	display: flex;
	align-items: center;
	gap: 12px;
	cursor: pointer;
`;

export const Logo = styled(CalmLogoCircle)`
	width: 44px;
	height: 44px;
`;

export const HeaderTitle = styled(Text).attrs({
	el: 'h3',
	weight: FontWeights.Demi,
})`
	font-size: 22px;
`;

export const Nav = styled.nav`
	display: flex;
	align-items: center;
	gap: 10px;
`;

export const NavButton = styled(Button).attrs({
	backgroundColor: 'accessibleBrandGradient',
})``;

export const ProfileMenuContainer = styled.div`
	position: relative;
`;

export const ProfileButton = styled.button`
	background: none;
	border: none;
	cursor: pointer;
	padding: 8px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 24px;
	transition: background-color 0.2s;
	background-color: ${({ $showMenu }: { $showMenu: boolean }) => ($showMenu ? '#f3f4f6' : 'transparent')};

	&:hover {
		background-color: ${({ $showMenu }: { $showMenu: boolean }) => ($showMenu ? '#f3f4f6' : '#f9fafb')};
	}
`;

export const ProfileMenu = styled.div`
	position: absolute;
	top: 100%;
	right: 0;
	margin-top: 8px;
	background-color: white;
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	box-shadow:
		0 10px 15px -3px rgba(0, 0, 0, 0.1),
		0 4px 6px -2px rgba(0, 0, 0, 0.05);
	padding: 8px 0;
	min-width: 180px;
	z-index: 60;
`;

export const UserInfo = styled.div`
	padding: 12px 16px;
	border-bottom: 1px solid #f3f4f6;
`;

export const UserName = styled(Text).attrs({
	el: 'p',
})`
	font-weight: bold;
	font-size: 14px;
`;

export const MenuButton = styled.button<{ disabled?: boolean }>`
	width: 100%;
	padding: 12px 16px;
	background: none;
	border: none;
	text-align: left;
	cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
	font-size: 14px;
	transition: background-color 0.2s;
	opacity: ${props => (props.disabled ? 0.5 : 1)};

	&:hover {
		background-color: ${props => (props.disabled ? 'transparent' : '#f9fafb')};
	}
`;
